
// const BaseUrl = "http://69.62.81.122:8000";

const BaseUrl = process.env.REACT_APP_API_URL || "http://localhost:6001";

export default BaseUrl; 
